import React from 'react'
import Image from 'next/image'
import styles from './whatsappChallan.module.scss'
import { NO_CHALLAN_HEADING, THUMBS_UP_PNG } from './constants'

interface Props {
  subHeading: string
}

const CenteredImage: React.FC<Props> = ({ subHeading }) => (
    <div className={styles.noChallanContainer}>
      <Image src={THUMBS_UP_PNG} alt="Reward Icon" width={80} height={80} />
      <h2 className={styles.heading}>{NO_CHALLAN_HEADING}</h2>
      <p className={styles.subHeading}>{subHeading}</p>
    </div>
  )

export default CenteredImage
